export const JOBS_URL = '/content.php?a=jobs'